import * as React from "react";
import styled from "@emotion/styled";

import { useRemainingCredits } from "lib/hooks/api/admin/credits/useRemainingCredits";
import { useSubscription } from "lib/hooks/subscription";
import { usePaywall } from "lib/providers/Paywall";
import { EventData } from "lib/tracking";
import { FeatureType } from "./paywallUtils";

type Props = {
  requiredDataType: "AWARDS" | "BIDS";
  creditType: "AWARD" | "BID";
  paywallFeatureType: FeatureType;
  children: React.ReactNode;
  trackingData?: EventData;
  contextSource?: string;
  strategyPaywall?: boolean;
};

export function CreditAccessWrapper({
  requiredDataType,
  creditType,
  paywallFeatureType,
  children,
  trackingData,
  contextSource,

  strategyPaywall = true,
}: Props) {
  const subscription = useSubscription();
  const hasDataType = subscription.hasDataTypes(requiredDataType);

  const { openPaywallModal } = usePaywall();

  const { data: credits } = useRemainingCredits(
    { creditType },
    {
      enabled: !hasDataType,
    },
  );

  const handleClick = (event: React.MouseEvent) => {
    if (!hasDataType && credits && credits.remainingCredits <= 0) {
      event.preventDefault();
      event.stopPropagation();

      openPaywallModal(paywallFeatureType, {
        strategyPaywall,
        requiredDataSubscription: requiredDataType,
        trackingData,
        contextSource,
      });
    }
  };
  // Use onClickCapture to override child onClick
  return <Wrapper onClickCapture={handleClick}>{children}</Wrapper>;
}

const Wrapper = styled.div({
  display: "contents",
});
